import { __assign } from "tslib";
import { connect } from 'react-redux';
import LoadingScreen from '../components/LoadingScreen';
import { areHotspotsLoaded } from '../selectors/hotspot';
import { getCompanyColourAndLogo, isEmbedded, isPro, } from '../selectors/project';
import { getPendingAndLoadedScreenCounts } from '../selectors/screen';
function mapStateToProps(state) {
    return __assign(__assign({ isPro: isPro(state), areHotspotsLoaded: areHotspotsLoaded(state), isEmbedded: isEmbedded(state) }, getPendingAndLoadedScreenCounts(state)), getCompanyColourAndLogo(state));
}
export default connect(mapStateToProps)(LoadingScreen);
